import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';

import { HTTPError, runBilling, type RunBilling } from '@enterprise/api';
import { ensureError } from '@enterprise/core';

import { useApplicationStore } from '@hooks/application/application-store.hook';

export const useTriggerBilling = () => {
  const enterpriseApi = useApplicationStore(({ enterpriseApi }) => {
    return enterpriseApi;
  });

  const toast = useToast();

  return useMutation({
    mutationFn: async (item: RunBilling) => {
      return await runBilling(enterpriseApi, item);
    },
    onError: (e) => {
      if (e instanceof HTTPError && e.response.status === 403) {
        return;
      }

      toast({
        description: ensureError(e).message,
        duration: 4000,
        isClosable: true,
        status: 'error',
        title: 'Failed to run billing',
      });
    },
    onSuccess: () => {
      toast({
        description:
          'Successfully triggered billing report. An email will be sent to your inbox once the report is ready.',
        isClosable: true,
        status: 'success',
        title: 'Billing Run',
      });
    },
  });
};
